import React from 'react';
import { ReactComponent as Image } from '../../assets/watermelon-pack-illustration-14.svg';

const NoPlanedSprint = () => {
	return (
		<div className=" w-full ml-4">
			<div className="flex p-8 sm:flex-row flex-col">
				<div className="w-40 h-40 lg:mr-16 mr-4 
                        flex-shrink-0">
					<Image />
				</div>
				<div className="flex-grow text-rigth m-10">
					<h6 className="text-gray-900 text-lg title-font font-medium mb-3">با یک اسپرینت برنامه ریزی کنید</h6>
					<p className="leading-relaxed text-base">
					به عنوان یک تیم، در مورد کارهایی که باید تکمیل شود توافق کنید و این مسائل را اسپرینت کنید 
					</p>
				</div>
			</div>
		</div>
	);
};

export default NoPlanedSprint;
